import { KIND } from 'baseui/button'
import { Delete } from 'baseui/icon'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import IconOpenInNew from '@/shared/icons/NewDesign/IconOpenInNew'
import IconPhoneCallback from '@/shared/icons/NewDesign/IconPhoneCallback'
import { CallbackReminderCardView } from '../useCallbackReminderPopup'
import {
  Actions,
  Card,
  CardSubtitle,
  CallStatus,
  CardTitle,
  CloseButton,
  CustomerName,
  CustomerPhone,
  Divider,
  IconBubble,
  StatusAndActions,
  TextBlock,
} from './styled-components'

type CallbackReminderCardProps = Omit<CallbackReminderCardView, 'id'>

const CallbackReminderCard = ({
  title,
  subtitle,
  customer,
  phone,
  hasCustomerDetails,
  isLate,
  hasContact,
  isDismissing,
  canCall,
  isCalling,
  callStatus,
  callFailed,
  closeLabel,
  openContactLabel,
  callLabel,
  onClose,
  onOpenContact,
  onCall,
}: CallbackReminderCardProps) => (
  <Card data-testid='callback-reminder-card' $isLate={isLate}>
    <IconBubble $isLate={isLate}>
      <IconPhoneCallback size={16} color='currentColor' />
    </IconBubble>
    <TextBlock>
      <CardTitle $isLate={isLate}>{title}</CardTitle>
      <CardSubtitle hidden={isLate}>{subtitle}</CardSubtitle>
    </TextBlock>
    <Divider hidden={!hasCustomerDetails} />
    <TextBlock hidden={!hasCustomerDetails}>
      <CustomerName hidden={!customer}>{customer}</CustomerName>
      <CustomerPhone hidden={!phone}>{phone}</CustomerPhone>
    </TextBlock>
    <StatusAndActions>
      <CallStatus role='status' $failed={callFailed} hidden={!callStatus}>
        {callStatus}
      </CallStatus>
      <Actions>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton kind={KIND.primary} disabled={isCalling} hidden={!canCall} onClick={onCall}>
          {callLabel}
        </SDButton>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton
          kind={KIND.secondary}
          disabled={isDismissing}
          hidden={!hasContact}
          onClick={onOpenContact}
          endEnhancer={<IconOpenInNew size={16} />}
        >
          {openContactLabel}
        </SDButton>
        <CloseButton type='button' aria-label={closeLabel} title={closeLabel} disabled={isDismissing} onClick={onClose}>
          <Delete size={20} />
        </CloseButton>
      </Actions>
    </StatusAndActions>
  </Card>
)

export default CallbackReminderCard
